import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import search_utils from "ulysses/widgets/search/utils";
import markup from "ulysses/widgets/indicators/indicator_list.html";

"use strict";
$(document).ready(function() { $(markup).appendTo($("body")); });

function DatasetModel(current_data) {
    var dataset_model = this;
    $.extend(this, {
       "dimensions":ko.observableArray([]),
       "values":ko.observableArray([]),
       "selected_dataset":ko.observable(null),
       "dataset": ko.observable(current_data.dataset),
       "dimension": ko.observable(current_data.dimension),
       "order_by": ko.observable(current_data.order_by),
       "limit": ko.observable(current_data.limit),
       "path": ko.observable(current_data.path),
       "extra_chart_filter": ko.observable(current_data.extra_chart_filter),
       "extra_solr_filter": ko.observable(current_data.extra_solr_filter),
       "serie": ko.observable(current_data.serie || null),
       "show_value": ko.observable(current_data.show_value),
       "show_percentage": ko.observable(current_data.show_percentage),
       "override_icon": ko.observable(current_data.override_icon),
       "override_colour": ko.observable(current_data.override_colour),
       "title_format": ko.observable(current_data.title_format),
       "caption_no_dimension": ko.observable(current_data.caption_no_dimension),
       "click_through_url": ko.observable(current_data.click_through_url)
    });

    this.selected_dataset.subscribe(function(dataset) {
        if (dataset) {
            var allowed_dims = $.map(ko.unwrap(dataset.dimensions), function(val,idx) {
                return val && ko.unwrap(val.field);
            });
            dataset_model.dimensions(allowed_dims);
            dataset_model.dataset(ko.unwrap(dataset.name));
            dataset_model.dimension.notifySubscribers(ko.unwrap(dataset_model.dimension));
        }
    });
}

function build_dataset_settings(settings_obs) {
        //extend missing props without losing exiting props.
        return $.extend({
            "dataset":null,
            "path":null,
            "value":null,
            "serie": null,
            "dimension":null,
            "chart_title":null,
            "order_by":null,
            "limit":10,
            "extra_chart_filter":null,
            "extra_solr_filter":null,
            "override_icon": null,
            "override_colour": null,
            "title_format": "{0}: {1}",
            "caption_no_dimension": null,
            "click_through_url": null
        }, ko.unwrap(settings_obs));
}


var select_dataset = function select_dataset(current_data) {
    var res = Promise.Deferred();
    var cdata = new DatasetModel(ko.toJS(current_data || {}));
    var charts =uly.api.start().follow("uly:datasets").follow("uly:cube").done(function(datasets) {
        cdata.datasets = datasets;
        var current_dataset = ko.unwrap(cdata.dataset);
        if (current_dataset) {
            $.each(datasets, function(idx,val) {
                if (val.name == current_dataset)
                    cdata.selected_dataset(val);
            });
        }

        var dialog = uly.dialogs.execute($("#indicatorlist-picker-tmpl").html() , {
            "title":_("indicatorlist_title_select_dataset", "Select Dataset"),
            "raw_data":true
        }, cdata).done(function([result]) {
            res.resolve({
                "dataset":ko.unwrap(result.dataset),
                "path":ko.unwrap(result.path),
                "serie":ko.toJS(result.serie),
                "dimension":ko.unwrap(result.dimension),
                "chart_title":ko.unwrap(result.chart_title),
                "order_by":ko.unwrap(result.order_by),
                "limit":ko.unwrap(result.limit),
                "extra_chart_filter":ko.unwrap(result.extra_chart_filter),
                "extra_solr_filter":ko.unwrap(result.extra_solr_filter),
                "override_icon": ko.unwrap(result.override_icon),
                "override_colour": ko.unwrap(result.override_colour),
                "title_format": ko.unwrap(result.title_format),
                "caption_no_dimension": ko.unwrap(result.caption_no_dimension)
            });
        }).fail(res.reject);

    }).fail(res.reject);
    return res.promise();
};
var modify_dataset = function modify_dataset(widget_model) {
    var res = Promise.Deferred();
    select_dataset(ko.unwrap(widget_model.settings)).done(function(result) {
        var new_settings = $.extend({}, ko.unwrap(widget_model.settings), result);
        widget_model.settings(new_settings);
        uly.publish("page.savesettings");
        res.resolve(result);
    }).fail(res.reject);
    return res.promise();
};

function build_indicator_model(settings_obs) {
    var model = {};
    $.extend(model, {
        "icon": ko.observable(ko.unwrap(settings_obs).override_icon || ko.unwrap(settings_obs).icon || "fa-dashboard"),
        "colour":ko.observable(ko.unwrap(settings_obs).override_colour || ko.unwrap(settings_obs).colour || "default"),
        "value":ko.observable(null),
        "caption":ko.observable(ko.unwrap(settings_obs).caption),
        "details_url":ko.observable(null),
        "hardcoded_model": ko.observable(null),
        "local_params": ko.observable(null),
        "indicator": ko.pureComputed(function() { return ko.unwrap(settings_obs).indicator; }),
        "search_settings": ko.observable({}),
        "path": ko.unwrap(settings_obs).path,
        "extra_filter": ko.unwrap(settings_obs).extra_filter,
        "extra_solr_filter": ko.unwrap(settings_obs).extra_solr_filter
    });
    return model;
}

function build_dataset(settings_obs, context) {
        var new_settings = build_dataset_settings(settings_obs);

        var data = {
            "icon":ko.observable("fa-unknown"),
            "colour":ko.observable("tomato"),
            "data":ko.observableArray([]),
            "map":ko.observable({}),
            "dataset_meta":ko.observable(null),
            "chart_title":ko.observable(null),
            "url":ko.observable(null),
            "local_params": ko.observable(null),
            "hardcoded_model": ko.observable(null),
            "drill_down_value":function(filter) {
                data.details_shown(false);
                data.column_filter(filter);
                var filter_obs = ko.unwrap(data.search_settings).filter;
                if (ko.isWritableObservable(filter_obs)) {
                    filter_obs(ko.unwrap(data.filter));
                } else if (!ko.isObservable(filter)) {
                    ko.unwrap(data.search_settings).filter = ko.unwrap(data.filter);
                }
                console.log("drilling down:", ko.unwrap(data.search_settings));
                data.details_shown(true);
            },
            "details_shown": ko.observable(false),
            "toggle_detail_action":function() {
                data.details_shown(!data.details_shown());
            },
            "column_expression": ko.observable(null),
            "chart_filter":ko.observable(null),
            "column_filter":ko.observable(null),
            "search_settings": ko.observable(search_utils.ensure_settings_complete({
                "navigable":false,
                "contextual":false,
                "filter": ko.observable(null),
                "parameters":{
                    _search_body:ko.observable(null)
                },
                "facets_visible": false
            })[0]),
            "activate_widget": function(datum) {
                var click_through_url = ko.unwrap(ko.unwrap(data.settings).click_through_url);
                if (click_through_url) {
                    console.log("datum:", datum, click_through_url, ko.unwrap(data.settings));
                    
                    var new_url = click_through_url.format(datum[result.map[dimension]] || caption_no_dimension, val._val1);
                    uly.actions.goto(new_url);                       
                } else {
                    var filter = get_indicator_filter(data.settings, data.map, data, datum.data_point);
                    console.log("drilling down:", filter);
                    data.drill_down_value(filter);
                }
            },
            "settings": settings_obs,
            "new_settings": new_settings
        };

        ko.unwrap(data.search_settings).hardcoded_model = ko.pureComputed(function() {
            return ko.unwrap(data.hardcoded_model);
        });

        ko.unwrap(data).filter = ko.pureComputed(function() {
            var local_params = ko.unwrap(data.local_params);

            var f1 = ko.unwrap(ko.unwrap(data).chart_filter);
            var f2 = ko.unwrap(ko.unwrap(data).column_filter);
            var filters = [];
            if (f1) filters.push(f1);
            if (f2) filters.push(f2);

            if (ko.unwrap(new_settings.path)) {
                var path = ko.unwrap(new_settings.path);
                var entity = uly.utils.get_bound_resource(context);
                if (path && entity) {
                    if (path.indexOf(":") > 0) {
                        path = path.split(":")[1];
                    }
                    filters.push("_parents:"+entity.unique_id+"."+path);
                }
            };
            var new_filters = [];
            $.each(filters, function(idx, f) {
                if (Array.isArray(f)) {
                    if (f.length > 1) {
                        new_filters.push( "(" + f.join(") AND (") + ")");
                    } else new_filters.push(f[0]);
                } else if (f.length) new_filters.push(f);
            });
            if (new_filters.length) {
                if (new_filters.length == 1) {
                    new_filters = new_filters[0];
                } else {
                    new_filters = "(" + new_filters.join(") AND (") + ")";
                }
            } else new_filters = null;

            if (new_filters) {
                if (local_params)
                   return local_params + new_filters;
                return new_filters;
            }
            return null;
        });
        data.search_settings.subscribe((newval) => {
            console.error("Setting search settings:", newval);
        })

        return data;
}

function rebuild_dataset(settings_obs, data_obs, context, queue) {
    var settings = ko.unwrap(settings_obs);

    var chart = ko.unwrap(settings.dataset);
    var dimension = ko.unwrap(settings.dimension);
    var serie = ko.unwrap(settings.serie);
    var limit = ko.unwrap(settings.limit) || undefined;
    var order_by = ko.unwrap(settings.order_by) || undefined;
    var extra_chart_filter = ko.unwrap(settings.extra_chart_filter);

    var dataset_meta = null;
    var dataset = uly.api.start().follow("uly:datasets").follow("find", { "rel":chart });
    dataset.done(function(result) {
        dataset_meta = result;
    });
    var path = ko.unwrap(settings.path);
    var bound = false;
    var entity = uly.utils.get_bound_resource(context);
    var group_by = dimension;
    if (order_by == "dimension")
        order_by = dimension;
    else order_by = "_val1 desc";

    var aggregates = [serie];
    if (path && entity) {
        dataset = dataset.follow("uly:results", {
            "origin":entity.unique_id,
            "path":path,
            "group_by":group_by,
            "aggregates":aggregates,
            "limit":limit,
            "order_by":order_by,
            "filters":extra_chart_filter
        });
        bound = true;
    } else {
        dataset = dataset.follow("uly:results", {
            "group_by":group_by,
            "aggregates":aggregates,
            "order_by":order_by,
            "limit":limit,
            "filters":extra_chart_filter
        });
    }

    return dataset.then(function(result) {
        var model = ko.unwrap(data_obs);
        result = result || {};
        var override_icon = ko.unwrap(settings_obs).override_icon;
        var override_colour = ko.unwrap(settings_obs).override_colour;
        var title_format = ko.unwrap(settings_obs).title_format || "{0}: {1}";
        var caption_no_dimension = ko.unwrap(settings_obs).caption_no_dimension || "";
        model.icon(result.icon);
        model.colour(result.colour);
        if (result.data) {
            result.data
        }
        model.data((result.data || []).map(function(val) {
            return {
                "value": val._val1,
                "caption": val[result.map[dimension]] || caption_no_dimension,
                "title": title_format.format(val[result.map[dimension]] || caption_no_dimension, val._val1),
                "icon": override_icon ? override_icon : dataset_meta ? ko.unwrap(dataset_meta.icon) : "fa-bar-chart",
                "colour": override_colour ? override_colour : dataset_meta ? ko.unwrap(dataset_meta.colour) : "primary",
                "data_point": val
            };
        }));
        model.map(result.map);
        model.dataset_meta(dataset_meta);
        var filters = null;
        if (dataset_meta.filters) {
            if (Array.isArray(dataset_meta.filters))
            {
                filters = $.map(dataset_meta.filters, function(value) {
                    if (value.solr_filter && value.solr_filter.length)
                        return "(" + value.solr_filter + ")";
                }).join(" AND ");
            }
            else if (dataset_meta.filters.length)
                filters = dataset_meta.filters;
        }
        if (dataset_meta.fact_entity)
        {
            if (filters && filters.length)
                filters = "(" + filters + ") AND (type:" + dataset_meta.fact_entity + ")";
            else filters = "type:" + dataset_meta.fact_entity;
        }

        if (ko.unwrap(settings.extra_solr_filter) && ko.unwrap(settings.extra_solr_filter).length) {
            if (filters && filters.length)
                filters = "(" + filters + ") AND (" + ko.unwrap(settings.extra_solr_filter) + ")";
            else filters = ko.unwrap(settings.extra_solr_filter);
        }
        model.local_params(dataset_meta.local_params);
        model.hardcoded_model(ko.unwrap(dataset_meta.hardcoded_model));
        model.chart_filter(filters);
        var candidates = null;
        if (dimension && dataset_meta.dimensions) {
            candidates = dataset_meta.dimensions.filter(function(v) { return v.field == dimension; });
            if (candidates.length) {
                model.column_expression(candidates[0].solr_filter);
            }
        }
        candidates = null;
        return { "result": result, "dataset_meta": dataset_meta };
    });
}

function get_indicator_filter(settings, map, chart_model, data_point) {
    // get those out of closure
    var settings = ko.unwrap(settings);
    var dimfield = ko.unwrap(settings.dimension);
    var actual_dim_field = ko.unwrap(map)[dimfield];
    var actual_dim_field_1 = ko.unwrap(map)[dimfield+"_1"];
    var actual_dim_field_2 = ko.unwrap(map)[dimfield+"_2"];
    var actual_dim_field_3 = ko.unwrap(map)[dimfield+"_3"];
    var column_expression = ko.unwrap(chart_model.column_expression);

    var dim_values = [];
    var dim_value = data_point[actual_dim_field];
    dim_values.push(dim_value || null);
    dim_values.push(data_point[actual_dim_field_1] || null);
    dim_values.push(data_point[actual_dim_field_2] || null);
    dim_values.push(data_point[actual_dim_field_3] || null);

    var filter = null;
    if (column_expression) {
        dim_values = $.map(dim_values, function(val,idx) {
            if (val instanceof Date)
                val = val.toISOString();
            return "{0}".format([val === null ? "null" : val]);
        });
        filter = column_expression.format(dim_values);
    }

    return filter;
}

ko.bindingHandlers.subindicatorlist = {
    "init": function(elt, va, allbindings, model, context) {
        var chart_data = build_dataset(va(), context);
        chart_data.details_shown.subscribe(function(newval) {
            if (allbindings().activate) {
                allbindings().activate(newval);
            }
        });
        if (allbindings().search_settings) {
            console.warn("overwriting search esttings:", allbindings().search_settings, ko.unwrap(allbindings().search_settings));
            chart_data.search_settings = allbindings().search_settings;
        }

        $(elt).data("indicatorlist_data", chart_data);
        var child = context.createChildContext(chart_data);
        ko.applyBindingsToDescendants(child, elt);
        return { controlsDescendantBindings: true };
    },
    "update": function(elt, va, allbindings, model, context) {
        var data_obs = $(elt).data("indicatorlist_data");
        var queue = ko.unwrap(allbindings().queue);
        var settings = ko.unwrap(ko.unwrap(data_obs).settings);
        var ready = allbindings().ready;
        rebuild_dataset(settings, data_obs, context, queue).then(() => {
            if (ready) ready.resolve(true);
        });
    }
};

ko.bindingHandlers.indicatorlist = {
    "init": function(elt, va, allbindings, model, context) {
        var widget_model = ko.unwrap(va());
        widget_model.title(_("chart_loading", "Loading..."));
        widget_model.icon("fa fa-dashboard");
        widget_model.show_header(true);
        var settings_menu = widget_model.settings_menu;
        settings_menu.push({
            "caption":_("indicatorlist_caption_modify_chart", "Modify Dataset"), 
            "icon":"fa-edit", 
            "action":function(e){
                modify_dataset(widget_model).done(function() {
                    widget_model.refresh();
                });
            },
            "colour":"default",
            "permission": "editpage"
        });
        var chart_data = build_dataset(widget_model.settings, context);
        widget_model.settings(chart_data.new_settings);
        chart_data.remove_action = function(ev) {
                var bindingcontext = ko.contextFor($(ev.target)[0]);
                if (context.widget_list) {
                    context.widget_list.splice(ko.unwrap(context.$index), 1);
                    uly.publish("page.savesettings");
                }
        };
        //setup force refresher
        if (!ko.isObservable(widget_model.refresher)) {
            widget_model.refresher = ko.observable(0);
            widget_model.refresh = function() { widget_model.refresher((widget_model.refresher() || 0) + 1); };
        }

        var entity_data = ko.observable(null);
        $(elt).data("widget_data", entity_data);
        $(elt).data("indicatorlist_data", chart_data);
        $(elt).on("dashboard:refresh", () => { console.log("refresh ilist"); widget_model.refresh(); });
        var child = context.createChildContext(chart_data);
        ko.applyBindingsToDescendants(child, elt);
        return { controlsDescendantBindings: true };
    },
    "update":function(elt, va, allbindings, model, context) {
        var data_obs = $(elt).data("indicatorlist_data");
        var widget_model = ko.unwrap(va());
        //subscribe to refresher
        var refresher_value = widget_model.refresher();

        var settings = ko.unwrap(widget_model.settings);
        rebuild_dataset(settings, data_obs, context).then(function(chart_result) {
            var result = chart_result.result;
            var dataset_meta = chart_result.dataset_meta;
            var model = ko.unwrap(data_obs);
            if (result.icon) {
                widget_model.icon(result.icon);
            }
            var sc = ko.unwrap(allbindings().show_colour);
            if (sc) {
                ko.bindingHandlers.colour.update(
                    elt,
                    function() { return model.colour; },
                    function() { return { class_prefix:"bg-"}; }
                );
            }
            var title = ko.unwrap(model.settings).chart_title || ko.unwrap(dataset_meta.title);
            if (!title) {
                widget_model.show_header(false);
                widget_model.panel_class(null);
            }
            else
            {
                widget_model.title("<h3 class='box-title'>"+title+"</h3>");
                var chart_icon  = ko.unwrap(dataset_meta.icon);
                if (chart_icon)
                {
                    widget_model.icon("fa " + chart_icon);
                }
                else
                {
                    widget_model.icon("fa fa-bar-chart-o");
                }
                //widget_model.icon(ko.unwrap(widget_model.settings).icon || "fa fa-chart");
                widget_model.panel_class("box box-starship");
                widget_model.show_header(true);
            }
            uly.publish("widget.active", elt);
        });

        widget_model.title('<h3 class="box-title">{0}</h3>'.format(_("chart_loading", "Loading...")));
        widget_model.icon("fa fa-spinner");
        uly.publish("widget.active", elt);
    }
};

uly.widgets.register({
    "type":"indicatorlist",
    "caption":_("indicator_caption_indicatorlist", "Dynamic Indicator List"),
    "description":_("indicator_indicatorlist_description_a_set_of_values_showing_something",
              "A list of values showing aggregate data "),
    "icon":"fa-dashboard",
    "init":function() {
        var data = {
            "dataset":ko.observable(null),
            "path":ko.observable(null),
            "serie":ko.observable(null),
            "dimension":ko.observable(null),
            "chart_title":ko.observable(null),
            "order_by":ko.observable(null),
            "limit":ko.observable(null),
            "extra_chart_filter":ko.observable(null),
            "extra_solr_filter":ko.observable(null),
            "override_icon": ko.observable(null),
            "override_colour": ko.observable(null),
            "title_format": ko.observable("{0}: {1}"),
            "caption_no_dimension": ko.observable(null),
            "click_through_url": ko.observable(null)
        };
        var init_def = Promise.Deferred();
        select_dataset(data).done(function(result) {
            data.dataset(result.dataset);
            data.path(result.path);
            data.dimension(result.dimension);
            data.serie(result.serie);
            data.chart_title(result.chart_title);
            data.order_by(result.order_by);
            data.limit(result.limit);
            data.extra_chart_filter(result.extra_chart_filter);
            data.extra_solr_filter(result.extra_solr_filter);
            data.override_icon(result.override_icon);
            data.override_colour(result.override_colour);
            data.title_format(result.title_format);
            data.caption_no_dimension(result.caption_no_dimension);
            data.click_through_url(result.click_through_url);
            init_def.resolve(ko.toJS(data));
        }).fail(init_def.reject);
        return init_def;
    },
    "colour":"java"
});

export default {
    select_indicator_list:select_dataset
};
